import React from 'react';
import styled from 'react-emotion';
import moment from 'moment';

// Because backend is refusing sending a date. Only the time between 00:00 to dayStart time
// will be rolled overed. Roll over will not happen if endtime is not within this range due
// to lack of data.
// Nevertheless, it is less likely that an end time of a shift will roll over to the next day.
// beyond this range. Can't imagine people working for more than 12 hours without sleep.
export const checkIsDiffWeekDay = (dayStart, time) => (
  moment(time, 'H:m').isBetween(moment('00:00:00', 'H:m:s'), moment(dayStart, 'H:m:s'))
);

const ShiftTime = ({
  dayStart, unassigned, shift: { fromTime, toTime, tasks },
}) => {
  const start = moment(fromTime, 'H:m');
  const end = moment(toTime, 'H:m');

  let startOffset = start
    .diff(moment(dayStart, 'H:m:s'), 'minutes');

  let endOffset = end
    .diff(moment(dayStart, 'H:m:s'), 'minutes');

  const calcWidth = t => t / 1440 * 100;

  if (checkIsDiffWeekDay(dayStart, fromTime)) {
    startOffset += 1440;
  }

  if (checkIsDiffWeekDay(dayStart, toTime)) {
    endOffset += 1440;
  }

  // This is to mitigate the issue for backend not sending the dates. If the
  // If fromTime is now bigger than toTime after adding a day, toTime must
  // add a day too.
  if (startOffset > endOffset) {
    endOffset += 1440;
  }

  const barWidth = endOffset - startOffset;

  const Gantt = styled('div')`
    font-size: 1rem;
    background-color: ${({ theme }) => unassigned ? theme.colors.greyscale[2] : theme.colors.clientSecondary};
    margin-left: ${calcWidth(startOffset)}%;
    width: ${calcWidth(barWidth)}%;
    user-select: none;
    opacity: .8;
  `;

  return <Gantt title={`${fromTime} - ${toTime}\n${tasks}`}>&nbsp;</Gantt>;
};

export default ShiftTime;
